export default __webpack_public_path__ + "static/media/chill-1.5x.4289ebd2.png";